import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import theme from 'config/theme';
import { Row } from 'components/Row';
import Spacing from 'components/Spacing';
import { PopupModal } from 'components/PopupModal';
import { getUrlParams, getPathWithRef, sanitizeHtml } from 'helpers/utils';
import { useAppSelector } from 'helpers/hooks';
import { useShareUrl } from 'hooks/useShareUrl';
import { getUserState } from 'selectors/user';
import { setRefValue } from 'services/storage';
import { IPage } from 'store/donatePage/types';
import { Title, Line, DescContainer, DescriptionCTA, HiddenContainer } from './styled';
import ImpactScoreHelper from './ImpactScoreHelper';

interface Props {
  page?: IPage;
}

export const ListDescription: FC<Props> = ({ page }) => {
  const navigate = useNavigate();
  const [pagesRequested, setPagesRequested] = useState(true);
  const [popupType, setPopupType] = useState('');
  const userState = useAppSelector(getUserState);

  const { isPopupOpen, setIsPopupOpen } = useShareUrl({
    userRefCode: userState.data?.ref_code,
    shareCurrentUrl: true,
    selectedTags: [],
  });

  useEffect(() => {
    if (page && pagesRequested) {
      const { urlRef } = getUrlParams();
      if (urlRef) setRefValue(urlRef);
      //TIP: This is the tag value returned from the partner url
      if (!page) navigate(getPathWithRef('/error'));
      setPagesRequested(false);
    }
  }, [page]);

  return (
    <div style={{ backgroundColor: theme.colors.white }}>
      {popupType === 'IMPACT' && (
        <PopupModal
          autoClose={false}
          closePopup={() => setIsPopupOpen(false)}
          isSelected={isPopupOpen}
          title="What’s the Impact Score?"
          description="Oath’s Impact Score is calculated from dozens of data points across three metrics: Competitiveness, Stakes, and Financial Need."
        />
      )}
      <DescContainer>
        <HiddenContainer $hiddenOnMobile={true}>
          <Row $justifyContent="space-between" $alignItems="center">
            <Title $smallOnly={true}>{page?.value}</Title>
          </Row>
        </HiddenContainer>
        <HiddenContainer $hiddenOnMobile={true}>
          <Spacing $size={8} />
          {page?.desc && (
            <DescriptionCTA
              $isCta={false}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(page?.desc) }}
            />
          )}
          {page?.page_cta && (
            <DescriptionCTA
              $isCta={true}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(page?.page_cta) }}
            />
          )}
        </HiddenContainer>
        <Spacing $size={16} />
        {page?.impact_score_visibility && (
          <ImpactScoreHelper setPopupType={setPopupType} setIsPopupOpen={setIsPopupOpen} />
        )}
        <Line />
      </DescContainer>
    </div>
  );
};
